import { normalizeTask } from '../../contracts/schemas.js'
import { sortImageNodes, sortTextNodes, uniqueRefs } from './task-order.js'

function inbound(nodes, edges, targetId) {
  const ids = new Set(edges.filter((edge) => edge?.to === targetId).map((edge) => edge.from))
  return nodes.filter((node) => ids.has(node?.id))
}

function collectRefs(nodes, edges, targetId, seen = new Set()) {
  if (seen.has(targetId)) return []
  seen.add(targetId)
  const refs = []
  for (const node of inbound(nodes, edges, targetId)) {
    if (node.type === 'ref' || node.type === 'image') refs.push(node.data?.image || node.data?.src || node.data?.url || { imageId: node.id })
    refs.push(...collectRefs(nodes, edges, node.id, seen))
  }
  return uniqueRefs(sortImageNodes(refs.map((ref, index) => typeof ref === 'object' ? { ...ref, id: ref.id || `ref_${index}`, x: ref.x || 0, y: ref.y || 0 } : { id: `ref_${index}`, value: ref, x: 0, y: index }).map((ref) => ref.value || ref)))
}

export function buildTasks({ nodes = [], edges = [], targetNodeId }) {
  const target = nodes.find((node) => node?.id === targetNodeId)
  if (!target || target.type !== 'gen') return { tasks: [], diagnostics: ['target-not-generatable'] }
  const sources = inbound(nodes, edges, targetNodeId)
  const textSources = sortTextNodes(sources.filter((node) => ['prompt', 'textout', 'combine', 'batch', 'llm'].includes(node?.type)))
  const refs = collectRefs(nodes, edges, targetNodeId)
  const fallbackText = target.data?.prompt || target.data?.text || ''
  const list = textSources.length ? textSources : (fallbackText ? [target] : [])
  const tasks = list.map((node, index) => normalizeTask({
    id: `${target.id}:${node.id}:${index}`,
    sourceNodeId: node.id,
    edgeId: edges.find((edge) => edge.to === target.id && edge.from === node.id)?.id || null,
    title: node.data?.title || node.type,
    text: node.data?.text || node.data?.prompt || node.data?.value || fallbackText,
    refs,
    variants: [{ ...target.data, count: Number(target.data?.count || 1) }],
    diagnostics: [],
  }))
  return { tasks, diagnostics: [] }
}
